import * as actions from '../actionTypes';
import { GET_INITIAL_STATE, LOGIN } from '../api';
import client from '../apolloClient';
import { setStudentsLocally } from './studentActions.js';
import { setSubjectInstancesLocally } from './subjectInstanceActions.js';
import { setDoneLoading } from '../actions/loadingActions';
export const login = (userInfo) => async (dispatch) => {
    try {
        const { data } = await client.mutate({
            mutation: LOGIN,
            variables: { input: userInfo },
        });
        const token = data.login.token;
        const students = data.login.students;
        const subjectInstances = data.login.subjectInstances;

        if (token) {
            localStorage.setItem('token', token);
            dispatch(setStudentsLocally(students));
            dispatch(setSubjectInstancesLocally(subjectInstances));
            dispatch(setDoneLoading(true));
        }
    } catch (error) {
        console.log(error);
    }
}
export const setInitialState = () => async (dispatch) => {
    try {
        const { data } = await client.query({
            query: GET_INITIAL_STATE,
        });
        const students = data.initialState.students;
        const subjectInstances = data.initialState.subjectInstances;
        dispatch(setStudentsLocally(students));
        dispatch(setSubjectInstancesLocally(subjectInstances));
        dispatch(setDoneLoading(true));
    } catch (error) {
        console.log(error);
    }
}